import { css, Global, withTheme } from '@emotion/react'

import * as React from 'react'

const GlobalCss = withTheme(() => (
  <Global
    styles={css`
      .leshen-table-wrapper {
        max-height: 450px;
        overflow-y: scroll;
      }
    `}
  />
))

export default GlobalCss
